<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
  
  new WOW().init();
  
  jQuery(".custom-nav-item a").each(function () {
        let currentPath = window.location.pathname;
 
        // Check if the item's href matches the current page's path
        if (currentPath.includes(jQuery(this).attr("href"))) {
            jQuery(this).parent().addClass("active");
        }
    });

// Open search modal
jQuery(document).on('click', '.header-flex-wrapper .header__search', function() {
  jQuery('.header-flex-wrapper details.search_details').prop('open', true); // open <details>
  jQuery('.header-search-close').css('display', 'block'); // show close button
  jQuery('.search-modal').css('display', 'block'); // hide close button
});

// Close search modal
jQuery(document).on('click', '.header-search-close', function() {
  if( jQuery('.header-flex-wrapper details.search_details').prop('open', false ).length == 1){
    jQuery('.header-flex-wrapper details.search_details').removeAttr('open');
    jQuery('.search-modal').fadeOut(); // hide modal
    jQuery(this).css('display', 'none'); // hide close button
  }
  jQuery('.header-flex-wrapper details.search_details').prop('open', false ); // close <details>
  jQuery('.search-modal').fadeOut(); // hide modal
  jQuery(this).css('display', 'none'); // hide close button
});

if( jQuery('.menu-lv-item.menu-lv-1.has-megamenu').length == 1 ) {
    jQuery('.menu-lv-item.menu-lv-1.has-megamenu').addClass('text-left no-megamenu');
    jQuery('.menu-lv-item.menu-lv-1.has-megamenu > a').addClass('link-effect');
    jQuery('.menu-lv-item.menu-lv-1.has-megamenu > a span').addClass('p-relative');
}

jQuery('.custom-nav .custom-nav-item').hover(
  function () {
    var $submenu = jQuery(this).find('ul.custom-submenu');
    var liCount = $submenu.find('li').length;

    if (liCount > 10) {
      $submenu.css({
        "display": "grid",
        "grid-template-columns": "1fr 1fr 1fr",
        "width": "max-content"
      });
    } else if (liCount > 4) {
      $submenu.css({
        "display": "grid",
        "grid-template-columns": "1fr 1fr",
        "width": "max-content"
      });
    } else {
      $submenu.css({
        "display": "block"
      });
    }
  },
  function () {
    // Reset styles when not hovered
    jQuery(this).find('ul.custom-submenu').css({
      "display": "",
      "grid-template-columns": ""
    });
  }
);


  
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper('.baby-slider', {
      loop: true,
      speed: 800,
      autoplay: {
        delay: 4000,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });


    new Swiper('.categories-slider', {
    slidesPerView: 2,
    spaceBetween: 26,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      550: {
        slidesPerView: 2,
      },
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
      1366: {
        slidesPerView: 6,
      }
    }
  });

    function showVariantDescription(variantId) {
      // Hide all
      $('.variant-meta-text').hide();

      // Show selected variant's description
      $('.variant-meta-text[data-variant-id="' + variantId + '"]').show();
    }

    var $variantSelect = $('[name="id"]'); // Shopify's variant dropdown

    if ($variantSelect.length) {
      // Show default selected variant on page load
      showVariantDescription($variantSelect.val());

      // Listen to variant changes
      $variantSelect.on('change', function() {
        showVariantDescription($(this).val());
      });
    }

    function showVariantDescriptionRow(variantId) {
      $('.variant-meta-row').hide(); // Hide all description rows
      $('.variant-meta-row[data-variant-id="' + variantId + '"]').show(); // Show selected
    }

    var $variantSelect = $('[name="id"]'); // Shopify's variant selector

    if ($variantSelect.length) {
      showVariantDescriptionRow($variantSelect.val()); // On page load

      $variantSelect.on('change', function() {
        showVariantDescriptionRow($(this).val()); // On variant change
      });
    }
    
  });

const items = document.querySelectorAll('.accordion button');

function toggleAccordion() {
  const itemToggle = this.getAttribute('aria-expanded');

  for (i = 0; i < items.length; i++) {
    items[i].setAttribute('aria-expanded', 'false');
  }

  if (itemToggle == 'false') {
    this.setAttribute('aria-expanded', 'true');
  }
}

items.forEach((item) => item.addEventListener('click', toggleAccordion));

const targetDivs = document.querySelectorAll('.gift_wrap_class, .cod_class, .return_exchange_class');
 
if (targetDivs.length > 0) {
    // Create the new parent div
    const parentDiv = document.createElement('div');
    parentDiv.classList.add('custom-parent');
 
    // Insert the parent div before the first targeted div
    targetDivs[0].parentNode.insertBefore(parentDiv, targetDivs[0]);
 
    // Move the targeted divs inside the new parent
    targetDivs.forEach(div => parentDiv.appendChild(div));
}





// Disable right-click on images
document.addEventListener('contextmenu', (e) => {
    if (e.target.tagName === 'IMG') {
        e.preventDefault();
        alert('Product images cannot be downloaded');
    }
});

// Disable drag-drop on images
document.addEventListener('dragstart', (e) => {
    if (e.target.tagName === 'IMG') {
        e.preventDefault();
    }
});

// Disable developer tools
document.onkeydown = function(e) {
    if (e.key == "F12" || 
        (e.ctrlKey && e.shiftKey && e.key == "I") ||
        (e.ctrlKey && e.shiftKey && e.key == "C")) {
        return false;
    }
};

// Disable text selection on product images
document.addEventListener('selectstart', (e) => {
    if (e.target.closest('.product-image')) {
        e.preventDefault();
    }
});


// ===== PRODUCT TEXT PROTECTION =====

// Prevent copy
document.addEventListener('copy', (e) => {
    e.preventDefault();
});

// Prevent cut
document.addEventListener('cut', (e) => {
    e.preventDefault();
});

// Prevent Ctrl+C, Ctrl+X, Ctrl+A
document.addEventListener('keydown', (e) => {
    if (e.ctrlKey || e.metaKey) {
        if (['c', 'C', 'x', 'X', 'a', 'A'].includes(e.key)) {
            e.preventDefault();
        }
    }
});

// Prevent text selection on product names
document.addEventListener('selectstart', (e) => {
    if (e.target.closest('h1') || 
        e.target.closest('.product-title') ||
        e.target.closest('.product-name')) {
        e.preventDefault();
    }
});

// Protect on right-click
document.addEventListener('contextmenu', (e) => {
    if (e.target.closest('.product-title')) {
        e.preventDefault();
        alert('NAQSH © - Text is protected');
    }
});



function removeSoldOutProducts() {
    document.querySelectorAll('.product-item.sold-out').forEach(function(item) {
        const li = item.closest('li.product');
        if (li) {
            li.style.display = 'none';
        }
    });
}